export const CARDS_PER_PACK = 15;
